
import { useMemo } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useAuthV2 } from '@/context/AuthContextV2';

/**
 * Hook that switches between AuthContext versions based on feature flag
 * This allows for gradual migration and easy rollback
 */
export const useAuthWithFeatureFlag = () => {
  // Feature flag - can be moved to environment variable or database
  const useAuthServiceLayer = localStorage.getItem('use_auth_service_layer') === 'true';
  
  const authV1 = useAuth();
  const authV2 = useAuthV2();
  
  return useMemo(() => {
    if (useAuthServiceLayer) {
      console.log('🔄 Using AuthContextV2 with dependency injection');
      return authV2;
    } else {
      console.log('🔄 Using original AuthContext');
      return authV1;
    }
  }, [useAuthServiceLayer, authV1, authV2]);
};

/**
 * Helper function to enable/disable the new auth service layer
 */
export const toggleAuthServiceLayer = (enabled: boolean) => {
  localStorage.setItem('use_auth_service_layer', enabled.toString());
  console.log(`Auth service layer ${enabled ? 'enabled' : 'disabled'}`);
  // Force page reload to apply changes
  window.location.reload();
};
